import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { FORTA_BLUE, FORTA_ERROR } from '../../../../../../../utils/colors';
import { Themes } from '../../../../../../../constants';
import { FHAccordion } from '../../../../../../../components/base';
import { getSessionSignatureStatusAndWarnings } from '../../../../utils';
import HeaderContentReadOnly from '../headerContentReadOnly';

import type { RootState } from '../../../../../../../store';

function HeaderReadOnly() {
  const theme = useTheme();
  const { t } = useTranslation('sessionNotes');
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { current: session } = useSelector((state: RootState) => state.sessions);

  const sessionSignAndWarningStatus = getSessionSignatureStatusAndWarnings(t, session);

  if (!session) return null;

  return (
    <Box
      sx={{
        border: `1px solid ${
          sessionSignAndWarningStatus?.showParentSignatureWarning ? FORTA_ERROR : FORTA_BLUE.light2
        }`,
        borderRadius: '8px',
        boxSizing: 'border-box',
      }}
    >
      {!isMobile && <HeaderContentReadOnly session={session} />}
      {isMobile && (
        <FHAccordion colorTheme={Themes.Primary} sx={{ boxShadow: 'none', border: 'none' }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ mt: 1 }} />}>
            <Typography sx={{ mt: isMobile ? 1 : 0 }}>Session details</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <HeaderContentReadOnly session={session} />
          </AccordionDetails>
        </FHAccordion>
      )}
    </Box>
  );
}

export default HeaderReadOnly;
